import React from 'react';
import './index.css';
import { FiDollarSign, FiCreditCard, FiPieChart } from 'react-icons/fi';

const CashCountStep = ({
  cashCount,
  handleCashQuantityChange,
  prevStep,
  nextStep
}) => (
<div className="cash-step">
    <div className="panelHeader">
      <h3>ARQUEO</h3>
      <div className="dateDisplay">
        {new Date().toLocaleDateString('es-ES', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
      </div>
    </div>

  <div className="cash-panels">
    {[{ label: 'Billetes', data: cashCount.bills, total: cashCount.totalBills }, 
    { label: 'Monedas', data: cashCount.coins, total: cashCount.totalCoins }].map((group, i) => (
      <section key={i} className="cash-panel">
        <div className="panel-header">
          <FiCreditCard className="panel-icon" />
          <h2>{group.label}</h2>
          <div className="panel-total">
            <span>Total: </span>
            <strong>{group.total.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</strong>
          </div>
        </div>

        <div className="denominations">
          <div className="denomination-row header">
            <span>Denominación</span>
            <span>Cantidad</span>
            <span>Subtotal</span>
          </div>
          {group.data.map((item, index) => (
            <div key={index} className="denomination-row">
              <span>${item.denomination.toFixed(2)}</span>
              <input
                type="number"
                className="quantity-input"
                value={item.quantity || ''}
                onChange={e => handleCashQuantityChange(group.label === 'Billetes' ? 'bills' : 'coins', index, e.target.value)}
                min="0"
              />
              <span>{item.total.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>
            </div>
          ))}
        </div>
      </section>
    ))}
  </div>

  <footer className="cash-summary">
    <div className="summary-card">
      <div className="summary-title">
        <FiPieChart />
        <h3>Totales</h3>
      </div>
      <div className="summary-values">
        <div className="summary-line">
          <span>Total Billetes</span>
          <span>{cashCount.totalBills.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>
        </div>
        <div className="summary-line">
          <span>Total Monedas</span>
          <span>{cashCount.totalCoins.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</span>
        </div>
        <div className="summary-divider" />
        <div className="summary-line total">
          <span>Total Efectivo</span>
          <strong>{cashCount.grandTotal.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</strong>
        </div>
      </div>
    </div>
  </footer>
</div>
);

export default CashCountStep;